module.exports = __webpack_public_path__ + "static/media/gruenes_heupferd_fenster.b916ac90.jpg";